import { Form as AntdForm, Select as AntdSelect } from 'antd'
import Flex from 'components/Flex'
import Label from 'components/Form/Label'
import CrossIcon from 'components/icons/CrossIcon'
import SelectArrowIcon from 'components/icons/SelectArrowIcon'
import React from 'react'
import styled from 'styled-components'

export const FormItem = styled(AntdForm.Item)`
  margin-bottom: ${props =>
    props.marginbottom ? props.marginbottom : '0px'} !important;
  width: ${props => props?.customWidth || '100%'};
  .ant-form-item-explain-error {
    padding-left: ${props => (props.padding ? '15%' : '0')};
  }
`

const { Option } = AntdSelect

const StyledSelect = styled(AntdSelect)`
  width: 100% !important;
  font-style: normal;
  font-weight: 500;
  font-size: ${props => (props.colorstyle ? '14px' : '16px')};
  line-height: 24px;
  color: ${props => (props?.color ? props?.color : '#010e30')};
  .ant-select-dropdown {
    background: red;
  }
  text-transform: ${props =>
    props.textTransformInitial ? 'initial' : 'capitalize'};

  .ant-select-selector {
    /* background-color: ${props =>
      !props.disabled
        ? props.backgroundcolor
          ? '#fafafb'
          : '#ffffff'
        : '#f5f5f5'} !important; */
    background-color: 'white';
    border-radius: 8px !important;
    border-color: #e9e9e9 !important;
    box-shadow: ${props =>
      props.boxShadow ? props.boxShadow : 'none'} !important;
  }
  .ant-select-item-option-content {
    background: red;
  }
  .ant-select-selection-item {
    background-color: ${props =>
      !props.disabled
        ? props?.mode === 'multiple' || props?.mode === 'tags'
          ? '#ebecee'
          : '#ffffff'
        : '#f5f5f5'};
    border-radius: 6px;
    font-weight: ${props => props.colorstyle && '600'};
    color: ${props =>
      props?.selectedOptionColor
        ? props?.selectedOptionColor
        : !props.disabled && '#010e30'};
  }
  .ant-select-multiple.ant-select-lg .ant-select-selection-item {
    background-color: ${props =>
      !props.disabled
        ? props?.mode === 'multiple' || props?.mode === 'tags'
          ? '#ebecee'
          : '#ffffff'
        : '#f5f5f5'};
  }
  :hover {
    border-radius: 6px;
    color: #010e30;
  }
  .ant-select-dropdown-placement-bottomLeft {
    width: 1000px !important;
  }
  .ant-select-selection-item-remove {
    display: flex;
    align-items: center;
  }
  .ant-select-selection-placeholder {
    font-size: ${props => (props.colorstyle ? '14px' : '16px')};
    font-weight: 500;
    line-height: 24px;
  }
  .ant-select-selection-placeholder {
    text-transform: none !important;
  }
`
const LabelWrapper = styled.div`
  padding-bottom: 8px;
`

export const FlexSection = styled(Flex)`
  .rc-virtual-list-holder {
    max-height: ${props =>
      props.customHeight ? `${props.customHeight} !important` : 'unset'};
  }
  .ant-select-dropdown {
    top: ${props => {
      return props.startFrom ? `${props.startFrom} !important` : 'auto'
    }};
  }
`

const Select = ({
  OptionData,
  placeholder,
  labelStyle,
  onChange,
  label,
  value,
  position = 'relative',
  width = '100%',
  defaultValue,
  loading,
  bordered = true,
  valueParam = 'id',
  nameParam = 'name',
  showSearch = true,
  backgroundcolor,
  name,
  rules,
  mode,
  disabled = false,
  onSearch,
  isKey = false,
  selectedPlaceId,
  colorstyle,
  color,
  customHeight,
  startFrom,
  listHeight = 200,
  customOptions = false,
  textTransformInitial = false,
  selectedOptions = [],
  selectedOptionColor,
  ...rest
}) => {
  return (
    <FormItem name={name} rules={rules} {...rest} key={name}>
      <FlexSection
        column
        style={{
          width: width,
          position: position,
        }}
        id={selectedPlaceId ?? 'select'}
        startFrom={startFrom}
        customHeight={customHeight}
      >
        {label && (
          <LabelWrapper>
            <Label labelStyle={labelStyle}>{label}</Label>
          </LabelWrapper>
        )}

        <StyledSelect
          showSearch={showSearch}
          suffixIcon={<SelectArrowIcon />}
          placeholder={placeholder}
          onChange={onChange}
          size={'large'}
          value={value || undefined}
          loading={loading}
          bordered={bordered}
          defaultValue={defaultValue}
          backgroundcolor={!value}
          removeIcon={<CrossIcon />}
          mode={mode}
          getPopupContainer={() =>
            document.getElementById(
              selectedPlaceId ? selectedPlaceId : 'select'
            )
          }
          selectedOptionColor={selectedOptionColor}
          listHeight={listHeight}
          disabled={disabled}
          onSearch={onSearch}
          filterOption={(inputValue, option) =>
            option[nameParam]
              ?.toString()
              ?.toLowerCase()
              .indexOf(inputValue?.toString().toLowerCase()) !== -1
          }
          colorstyle={colorstyle}
          textTransformInitial={textTransformInitial}
          {...rest}
          color={color}
        >
          {(Array.isArray(OptionData) ? OptionData : []).map((option, index) => {
            if (!option[nameParam]) {
              return null
            }
            return (
              <Option
                style={{
                  padding: '10px 12px',
                  color: option?.color ? option?.color : 'unset',
                }}
                className={'colorChanges'}
                key={index}
                value={option[valueParam]}
                id={option?.id}
                name={option[nameParam]}
                option={option}
                formName={name}
                disabled={
                  customOptions
                    ? selectedOptions?.includes(option[valueParam])
                    : false
                }
              >
                {option[nameParam]}
              </Option>
            )
          })}
        </StyledSelect>
      </FlexSection>
    </FormItem>
  )
}

export default Select
